module.exports = __webpack_public_path__ + "static/petra_split-4bbfcbd530a5fa99e97663e2acb9b71a.png";